import React from 'react'
import './BTHeadline.css'

const BTHeadline = () => {
    return (
        <section className="member-tutorials-headline">
            <div className="container">
                <div className="m-t-headline-main">
                    <h1 className="m-t-h-invisible-title">Video</h1>
                    <h2 className="m-t-h-title">Video Tutorials</h2>
                    <p className="m-t-h-description">
                    Here are some simple how to videos on using the business app. See below videos on how to set up your business profile, add products, configure payment methods,  send payments requests and more.
                    </p>
                </div>
            </div>
        </section>
    )
}

export default BTHeadline
